import {Component, OnDestroy, OnInit} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {Globals} from '../../globals/Globals';
import {Router} from '@angular/router';
import {MainComponent} from './main.component';
import {TreeNode} from 'primeng/primeng';
import {DashboardParamsModel} from './dashboard-params-model';
import {DashboardDataService} from '../../services/dashboard-data.service';
import {isNullOrUndefined, isUndefined} from 'util';
import {ClientsService} from '../../services/clients/clients.service';
import {SuperClass} from '../../superclass/SuperClass';
import {WsService} from '../../services/websocket/WsService';
import {WsConst} from '../../globals/WsConst';
import {HttpClient} from '@angular/common/http';
import {forkJoin} from "rxjs/observable/forkJoin";

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.scss'],
})
export class AppTopBarComponent extends SuperClass implements OnDestroy {
  // for query window start
  selectedVenueGroup;
  queryParams: DashboardParamsModel;
  newQueryParams: DashboardParamsModel;
  timeWindows;
  months;
  weeks;
  days;
  hours;
  venueGroupsTree: TreeNode[];

  displayQueryParams: boolean;
  paramsSubscriber;
  loadingSubscriber;
  clients;
  selectedClient;
  initials;
  initArr = [];
  loading: boolean = false;
  // for query window end
  private timeWindowsLoaded = false;
  private monthsLoaded = false;
  private weeksLoaded = false;
  private hoursLoaded = false;

  constructor(
    public app: MainComponent,
    private router: Router,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.loadingSubscriber = this.dashboardDataService.getLoadingState().subscribe(state => {
      this.loading = state;
    });
  }

  updatevenueGroupsTree(venueGroupsTree: TreeNode[]): TreeNode[] {
    venueGroupsTree.forEach(item => {
      if (item.children) {
        item.children = this.updatevenueGroupsTree(item.children);
      }
      if (!item.expanded)
        item.label = item.data + ' - ' + item.label;
    });
    return venueGroupsTree;
  }

  reloadData() {
    this.http_getAllClients((data: any) => {

      this.clients = data.payload;

      if (this.clients[0].id === -5) {
        this.clients = this.clients[0].children;
      }

      const cookieClient = this.cookiesService.check(Globals.COOKIES_CLIENT_ID);
      if (!cookieClient) {
        this.cookiesService.set(Globals.COOKIES_CLIENT_ID, this.clients[0].id);
      } else {
        this.clients.filter(el => {
          const cookieId = this.cookiesService.get(Globals.COOKIES_CLIENT_ID);
          if (el.id.toString() === cookieId) {
            this.selectedClient = el;
          }
        });
      }

      this.http_getTreeInfo(
        {
          withLocations: true,
          getAll: false,
          withNoParent: false,
        },
        (treeData: any) => {
          if (treeData.result === Globals.RESPONSE_RESULT_SUCCESS) {
            this.venueGroupsTree = JSON.parse(treeData.payload);
            this.venueGroupsTree = this.updatevenueGroupsTree(this.venueGroupsTree);
            this.dashboardDataService.getParams();
          }
        },
      );

      this.queryParams = new DashboardParamsModel();

      const date = new Date();

      this.paramsSubscriber = this.dashboardDataService
        .getParamsSubscriber()
        .subscribe((paramsData: DashboardParamsModel) => {
          this.detectVenueGroup(this.venueGroupsTree, paramsData.venueGroup);
          const timeWindow = paramsData.timeWindowSelect.timeWindow;

          this.queryParams = paramsData;

          if (timeWindow === 'D' || timeWindow === 'H') {
            this.loadDaysForMonth();
          }
        });

      this.loadForQuery();
    });
    this.initials = this.getLetters(localStorage.getItem('initials'));
  }

  getWebSocketIdentifier() {
    return WsConst.TOP_BAR;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.paramsSubscriber.unsubscribe();
    this.loadingSubscriber.unsubscribe();
  }

  getLetters(initial) {
    this.initArr = [];
    const arr = initial.split(' ');
    for (let i = 0; i < arr.length; i++) {
      this.initArr.push(arr[i].charAt(0).toUpperCase());
    }
    if (this.initArr.length === 1) {
      const letterId = document.getElementById('inName');
      letterId.classList.add('one_letter');
    }
    return this.initArr.join('');
  }

  chooseClient(e) {
    this.clients.filter(el => {
      if (e.value.clientName === el.clientName) {
        this.cookiesService.set(Globals.COOKIES_CLIENT_ID, el.id);
        this.clientsService.clientChanged();
      }
    });
  }

  timeWindowChanged() {
    const date = new Date();
    switch (this.queryParams.timeWindowSelect.timeWindow) {
      case 'H': {
        this.queryParams.daySelect = {
          monthSelect: this.months[0],
          dayOfMonth: date.getDate(),
          description: '',
        };
        this.loadDaysForMonth();
        break;
      }
      case 'D': {
        this.queryParams.daySelect = {
          monthSelect: this.months[0],
          dayOfMonth: date.getDate(),
          description: '',
        };
        this.loadDaysForMonth();
        break;
      }
      case 'W': {
        if (isUndefined(this.queryParams.weekSelect))
          this.queryParams.weekSelect = this.weeks[0];
        break;
      }
      case 'M': {
        this.queryParams.monthSelect = this.months[0];
        break;
      }
      case 'DR': {
        this.queryParams.end = new Date();
        this.queryParams.start = new Date(this.queryParams.end - 30 * 24 * 60 * 60 * 1000);
        break;
      }
    }
  }

  monthForDayChanged() {
    this.loadDaysForMonth();
  }

  loadDaysForMonth() {
    this.http_getDaysForMonth(
      this.queryParams.daySelect.monthSelect,
      (data: any) => {
        let loadCurrent = false;
        if (isNullOrUndefined(this.days)) {
          let loadCurrent = true;
        }

        this.days = data.payload;
        const date = new Date();
        if (loadCurrent) {
          this.queryParams.daySelect = this.days.filter(el => {
            return el.dayOfMonth === date.getDate();
          })[0];
          this.queryParams.hourSelect = this.hours.filter(el => {
            return el.hour === date.getHours();
          })[0];
        } else {
          this.newQueryParams = new DashboardParamsModel();
          this.newQueryParams.daySelect = this.days[0];

          if (this.queryParams.daySelect.monthSelect.month !== this.newQueryParams.daySelect.monthSelect.month) {
            this.queryParams.daySelect = this.days[0];
          }

          this.queryParams.hourSelect = this.hours[0];
        }
      },
    );
  }

  updateDashboard() {
    if (this.loading)
      return;

    this.queryParams.venueGroup = this.selectedVenueGroup.data;
    if (this.queryParams.timeWindowSelect.timeWindow === 'DR') {
      this.queryParams.startYear = this.queryParams.start.getFullYear();
      this.queryParams.startMonth = this.queryParams.start.getMonth();
      this.queryParams.startDay = this.queryParams.start.getDate();
      this.queryParams.endYear = this.queryParams.end.getFullYear();
      this.queryParams.endMonth = this.queryParams.end.getMonth();
      this.queryParams.endDay = this.queryParams.end.getDate();
    }

    DashboardDataService.dashboardData = undefined;
    if (this.queryParams.monthSelect === null) {
      if (this.queryParams.daySelect === null)
        this.timeWindowChanged();
    }

    this.dashboardDataService.setDashboardParams(this.queryParams);
    this.dashboardDataService.getDD('AppTopBarComponent');
  }

  detectVenueGroup(tree: TreeNode[], venueGroup: string) {
    if (isUndefined(tree) || tree.length === 0 || venueGroup === null) {
      return;
    }
    const thisObj = this;
    tree.forEach((el: any) => {
      if (el.data.trim() === venueGroup.trim()) {
        thisObj.selectedVenueGroup = el;
        return;
      }
      thisObj.detectVenueGroup(el.children, venueGroup);
    });
  }

  private loadForQuery() {
    this.http_getTimeWindows((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.timeWindowsLoaded = true;
        this.timeWindows = data.payload;
        if (
          this.timeWindowsLoaded &&
          this.hoursLoaded &&
          this.monthsLoaded &&
          this.weeksLoaded
        ) {
          this.dashboardDataService.getParams();
        }
      }
    });
    this.http_getMonths((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.monthsLoaded = true;
        this.months = data.payload;
        if (
          this.timeWindowsLoaded &&
          this.hoursLoaded &&
          this.monthsLoaded &&
          this.weeksLoaded
        ) {
          this.dashboardDataService.getParams();
        }
      }
    });
    this.http_getWeeks((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.weeksLoaded = true;
        this.weeks = data.payload;
        if (
          this.timeWindowsLoaded &&
          this.hoursLoaded &&
          this.monthsLoaded &&
          this.weeksLoaded
        ) {
          this.dashboardDataService.getParams();
        }
      }
    });
    this.http_getHours((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.hoursLoaded = true;
        this.hours = data.payload;
        if (
          this.timeWindowsLoaded &&
          this.hoursLoaded &&
          this.monthsLoaded &&
          this.weeksLoaded
        ) {
          this.dashboardDataService.getParams();
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/main/app.topbar.component.ts